module.exports = __webpack_public_path__ + "img/Path 22 Copy@3x.8883eb31.png";